import { useQuery } from 'react-query';
import api from 'src/services/api';
import { APPLICATION_QUERY_KEY } from 'src/constants/query';

const getApplication = ({ applicationId, signal }) =>
  api.get(`/application/${applicationId}`, { ...(signal ? { signal } : {}) });

export const useApplication = ({ applicationId }) =>
  useQuery(
    [APPLICATION_QUERY_KEY, applicationId],
    ({ signal }) => getApplication({ applicationId, signal }),
    { enabled: !!applicationId },
  );
